// extracted by mini-css-extract-plugin
export var childrenContainer = "_54-0";
export var virtualScrollArea = "_54-1";